/**
 * applicationTermsText.ts (InstaLOD GmbH)
 *
 * Copyright © 2026 InstaLOD GmbH - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * This file and all its contents are proprietary and confidential.
 *
 * @file applicationTermsText.ts
 * @copyright 2026 InstaLOD GmbH. All rights reserved.
 * @section License
 */

export const DEFAULT_TERMS_URL = 'https://theabstract.co/toc/';

const URL_PLACEHOLDER = /\{\{URL\}\}/g;
const ANCHOR_WITH_URL_PLACEHOLDER = /<a\b[^>]*\{\{URL\}\}[^>]*>([\s\S]*?)<\/a>/gi;

/**
 * Resolve `{{URL}}` placeholders in a terms-text template.
 *
 * - When `url` has a value, it is substituted into `{{URL}}`.
 * - When `url` is blank and a `fallback` is provided, the fallback URL is substituted.
 * - When `url` is blank and no `fallback` is provided, any `<a …>…</a>` whose href
 *   contains `{{URL}}` is unwrapped, leaving the inner text in place. This is the
 *   SLA-flow behavior: applications without an SLA URL render plain text instead
 *   of a broken hyperlink.
 */
export const resolveTermsURL = (
  text: string | null | undefined,
  url: string | null | undefined,
  fallback?: string
): string => {
  if (!text) {
    return text ?? '';
  }

  const trimmed = typeof url === 'string' ? url.trim() : '';
  const effectiveURL = trimmed !== '' ? trimmed : fallback;

  if (effectiveURL) {
    return text.replace(URL_PLACEHOLDER, effectiveURL);
  }

  return text.replace(ANCHOR_WITH_URL_PLACEHOLDER, '$1');
};
